import customers from "../services/customers";
import points from "../services/points";
import notification from "../services/notification";
import purchasePackages from "../services/purchase.packages";
import auth from "./auth";

export default {
    namespaced: true,

    state: {
        error: false,
        errors: null,
        loading: false,
        notification: null,
        view: null,
        list: [],
        page: 1,
        perPage: 10,
        prevPage: null,
        nextPage: null,
        maxPage: null,
        startList: null,
        endList: null,
        message: null,
        merchantUuid: auth.state.user.merchant_uuid,
        search: {
            keyword: null,
            filter: null,
            dateFrom: null,
            dateTo: null
        },
        customer: {
            uuid: null,
            firstname: null,
            lastname: null,
            email: null,
            mobile_number: null,
            registration_channel: null,
            gender: null,
            civil_status: null,
            birthdate: null,
            address_1: null,
            address_2: null,
            country: null,
            province: null,
            city: null,
            zipcode: null,
            profile_image: null
        },
        form: {
            uuid: null,
            firstname: null,
            lastname: null,
            email: null,
            mobile_number: null,
            registration_channel: null,
            membership_id: null,
            gender: null,
            civil_status: null,
            birthdate: null,
            address_1: null,
            address_2: null,
            country: null,
            province: null,
            city: null,
            zipcode: null,
            profile_image: null,
            text1: null,
            text2: null,
            text3: null,
            text4: null,
            text5: null
        },
        enable: {
            firstname: true,
            lastname: true,
            email: true,
            mobile: true,
            registration_channel: true,
            gender: true,
            civil_status: true,
            birthdate: true,
            address_1: false,
            address_2: false,
            country: false,
            province: false,
            city: false,
            zipcode: false,
            profile_image: false,
            text1: false,
            text2: false,
            text3: false,
            text4: false,
            text5: false,
            membership_id: null
        },
        additional: false,
        uuid: null,
        import: false,
        importfile: null,
        importBase: null,
        amountSpent: 0,
        pointEarned: 0,
        pointsRedeemed: 0,
        currentTotalPoints: 0,
        currentBalance: 0,
        cardNumbers: [],
        membership_id: null,
        custom_fields: {
            text1: null,
            text2: null,
            text3: null,
            text4: null,
            text5: null
        },
        importUuid: null,
        importUuids: [],
        summaryCount: {},
        specialDiscountIds: [],
    },
    getters: {
        searchParameters: state => state.search,
    },
    mutations: {
        setSearchFilter(state, filter) {
            state.search.keyword = filter.keyword;
            state.search.filter = filter.filter == "all" ? null : filter.filter;
            state.search.dateFrom = filter.dateFrom;
            state.search.dateTo = filter.dateTo;
        },
        getList(state, response) {
            state.list = response.list;
            state.maxPage = response.max_page;
            state.nextPage = response.next_page;
            state.prevPage = response.prev_page;
            state.message = response.message;

            if (state.page == 1) {
                state.startList = 1;
            } else {
                state.startList = state.perPage * (state.page - 1) + 1;
            }

            if (state.page == state.maxPage) {
                let count = state.list.length;
                state.endList = state.perPage * (state.page - 1) + count;
            } else {
                state.endList = state.perPage * state.page;
            }
        },

        getNext(state) {
            state.page = state.nextPage;
        },

        getPrev(state) {
            state.page = state.prevPage;
        },

        setPage(state, page) {
            state.page = page;
        },

        setUuid(state, uuid) {
            state.uuid = uuid;
        },

        setImportFile(state, importfile) {
            state.importfile = importfile;
        },

        setImportBase(state, importBase) {
            state.importBase = importBase;
            state.import = true;
        },
        setImportBaseDefault(state) {
            state.importBase = null;
            state.import = false;
        },
        setProfileDefault(state) {
            state.form.uuid = null;
            state.form.firstname = null;
            state.form.lastname = null;
            state.form.mobile_number = null;
            state.form.email = null;
            state.form.registration_channel = null;
            state.form.gender = null;
            state.form.civil_status = null;
            state.form.birthdate = null;
            state.form.address_1 = null;
            state.form.address_2 = null;
            state.form.country = null;
            state.form.province = null;
            state.form.city = null;
            state.form.zipcode = null;
            state.form.profile_image = null;
        },

        getProfile(state, response) {
            state.customer.uuid = response.uuid;
            state.customer.firstname = response.firstname;
            state.customer.lastname = response.lastname;
            state.customer.mobile_number = response.mobile_number;
            state.customer.email = response.email;
            state.customer.registration_channel = response.registration_channel;
            state.customer.gender = response.gender;
            state.customer.civil_status = response.civil_status;
            state.customer.birthdate =
                response.birthdate != "0000-00-00" ? response.birthdate : null;
            state.customer.address_1 = response.address_1;
            state.customer.address_2 = response.address_2;
            state.customer.country = response.country;
            state.customer.province = response.province;
            state.customer.city = response.city;
            state.customer.zipcode = response.zipcode;
            state.customer.profile_image = response.profile_image;

            state.form.uuid = response.uuid;
            state.form.firstname = response.firstname;
            state.form.lastname = response.lastname;
            state.form.mobile_number = response.mobile_number;
            state.form.email = response.email;
            state.form.registration_channel = response.registration_channel;
            state.form.gender = response.gender;
            state.form.civil_status = response.civil_status;
            state.form.birthdate =
                response.birthdate != "0000-00-00" ? response.birthdate : null;

            state.form.address_1 = response.address_1;
            state.form.address_2 = response.address_2;
            state.form.country = response.country;
            state.form.province = response.province;
            state.form.city = response.city;
            state.form.zipcode = response.zipcode;
            state.form.profile_image = response.profile_image;
            state.form.text1 = response.text1;
            state.form.text2 = response.text2;
            state.form.text3 = response.text3;
            state.form.text4 = response.text4;
            state.form.text5 = response.text5;
            state.form.membership_id = response.membership_id;
        },

        setProfile(state, response) {
            state.form.uuid = response.uuid;
            state.form.firstname = response.firstname;
            state.form.lastname = response.lastname;
            state.form.mobile_number = response.mobile_number;
            state.form.email = response.email;
            state.form.registration_channel = response.registration_channel;
            state.form.gender = response.gender;
            state.form.civil_status = response.civil_status;
            state.form.birthdate = response.birthdate;
            state.form.address_1 = response.address_1;
            state.form.address_2 = response.address_2;
            state.form.country = response.country;
            state.form.province = response.province;
            state.form.city = response.city;
            state.form.zipcode = response.zipcode;
            state.form.text1 = response.text1;
            state.form.text2 = response.text2;
            state.form.text3 = response.text3;
            state.form.text4 = response.text4;
            state.form.text5 = response.text5;
        },

        setCustomer(state, response) {
            state.customer.uuid = response.uuid;
            state.customer.firstname = response.firstname;
            state.customer.lastname = response.lastname;
            state.customer.mobile_number = response.mobile_number;
            state.customer.email = response.email;
            state.customer.registration_channel = response.registration_channel;
            state.customer.gender = response.gender;
            state.customer.civil_status = response.civil_status;
            state.customer.birthdate = response.birthdate;
            state.customer.address_1 = response.address_1;
            state.customer.address_2 = response.address_2;
            state.customer.country = response.country;
            state.customer.province = response.province;
            state.customer.city = response.city;
            state.customer.zipcode = response.zipcode;
            state.customer.text1 = response.text1;
            state.customer.text2 = response.text2;
            state.customer.text3 = response.text3;
            state.customer.text4 = response.text4;
            state.customer.text5 = response.text5;
        },

        setHidden(state, response) {
            let keys = Object.keys(response);

            if (keys.includes("country")) {
                state.enable.country = true;
                state.additional = true;
            }

            if (keys.includes("province")) {
                state.enable.province = true;
                state.additional = true;
            }

            if (keys.includes("city")) {
                state.enable.city = true;
                state.additional = true;
            }

            if (keys.includes("zipcode")) {
                state.enable.zipcode = true;
                state.additional = true;
            }

            if (keys.includes("text1")) {
                state.enable.text1 = true;
                state.additional = true;
                state.custom_fields.text1 = response.text1;
            }

            if (keys.includes("text2")) {
                state.enable.text2 = true;
                state.additional = true;
                state.custom_fields.text2 = response.text2;
            }

            if (keys.includes("text3")) {
                state.enable.text3 = true;
                state.additional = true;
                state.custom_fields.text3 = response.text3;
            }

            if (keys.includes("text4")) {
                state.enable.text4 = true;
                state.additional = true;
                state.custom_fields.text4 = response.text4;
            }

            if (keys.includes("text5")) {
                state.enable.text5 = true;
                state.additional = true;
                state.custom_fields.text5 = response.text5;
            }
        },

        setPointsInfo(state, response) {
            state.amountSpent = response.amount_spent;
            state.pointEarned = response.earned;
            state.pointsRedeemed = response.redeemed;
            state.currentTotalPoints = response.redeemed;
        },

        setPointsDefault(state) {
            state.amountSpent = 0;
            state.pointEarned = 0;
            state.pointsRedeemed = 0;
            state.currentTotalPoints = 0;
        },

        setCurrentBalance(state, response) {
            state.currentBalance = response.balance;
        },

        setCurrentBalanceDefault(state) {
            state.currentBalance = 0;
        },

        setCardNumbers(state, response) {
            state.cardNumbers = response.list;
        },

        setCardNumbersDefault(state) {
            state.cardNumbers = [];
        },

        loading(state, payload) {
            state.loading = payload;
        },

        errors(state, errors) {
            state.error = true;
            state.errors = errors;
        },

        setErrorDefault(state) {
            state.error = false;
            state.errors = {};
        },

        setMembershipID(state, membership_id) {
            state.membership_id = membership_id;
        },
        setImportUuid(state, importUuid) {
            state.importUuid = importUuid;
        },
        setImportUuids(state, importUuid) {
            state.importUuids.push(importUuid);
        },
        removeUuidFromImportUuids(state, importUuid) {
            state.importUuids = state.importUuids.filter(
                uuid => uuid !== importUuid
            );
        },
        setSummaryCount(state, summaryCount) {
            state.summaryCount = summaryCount;
        },
        setSdIds(state, response){
            state.specialDiscountIds = response
        },
        setErrorState(state, errorState) {
            state.error = errorState;
        },
    },

    actions: {
        getCustomerFields: async ({ commit }) => {
            commit("loading", true);

            try {
                let response = await customers.getCustomerFields();

                commit("setHidden", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        getList: async ({ commit, state }, { page, payload }) => {
            commit("loading", true);
            commit("setPage", page);

            try {
                let response = await customers.getList(
                    page,
                    payload
                );

                commit("getList", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        getNext({ commit, dispatch }) {
            commit("getNext");
            dispatch("getList");
        },

        getPrev({ commit, dispatch }) {
            commit("getPrev");
            dispatch("getList");
        },

        getProfile: async ({ commit, state }) => {
            commit("loading", true);
            commit("setProfileDefault");

            try {
                let response = await customers.getProfile(state.uuid);

                commit("getProfile", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        getPointsInfo: async ({ commit, state }) => {
            commit("loading", true);
            commit("setPointsDefault");

            try {
                let response = await points.getPointsInfo(state.uuid);
                commit("setPointsInfo", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        getCardNumbers: async ({ commit, state }) => {
            commit("loading", true);
            commit("setCardNumbersDefault");

            try {
                let response = await purchasePackages.getCardNumbers(
                    state.uuid
                );
                commit("setCardNumbers", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        getCurrentBalance: async ({ commit, state }) => {
            commit("loading", true);
            commit("setCurrentBalanceDefault");

            try {
                let response = await points.getCurrentBalance(state.uuid);
                commit("setCurrentBalance", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        updateProfile: async ({ commit, state }) => {
            commit("loading", true);
            commit("setErrorDefault");

            try {
                let response = await customers.updateProfile(
                    state.form.uuid,
                    state.form
                );

                commit("setCustomer", state.form);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        exportCustomer: async ({ commit, state }) => {
            commit("loading", true);
            commit("errors", null);

            try {
                console.log(state.search);
                await customers.export(state.search);
                notification.success(
                    "Your data is being exported. You will receive it via email."
                );

            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot export customers.");
            } finally {
                commit("loading", false);
            }
        },

        readImport({ commit, state }) {
            let reader = new FileReader();
            reader.readAsDataURL(state.importfile);

            reader.onload = e => {
                commit("setImportBase", e.target.result.split("base64,").pop());
            };
        },

        importCustomer: async ({ commit }, payload) => {
            commit("loading", true);

            try {
                const response = await customers.import(payload);

                commit("setImportUuid", response.import_uuid); // Set import data for initial notification
                commit("setImportUuids", response.import_uuid); // List of UUIDs being uploaded
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        getMembershipID: async ({ commit }, param) => {
            try {
                let response = await customers.getMembershipID();

                response.list.forEach(function (customer) {
                    if (customer.uuid === param.uuid) {
                        commit("setMembershipID", customer.membership_id);
                    }
                });
            } catch (errors) {
                commit("errors", errors);
            }
        },

        async getImportsStatus({ commit }, param) {
            try {
                let response = await customers.getImportsStatus(param);
                return response;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        removeUuidFromImportUuids({ commit }, uuid) {
            commit("removeUuidFromImportUuids", uuid);
        },
        async getSummaryCount({ commit }, params = {}) {
            try {
                let response = await customers.getSummaryCount(params);
                commit("setSummaryCount", response.data);
            } catch (errors) {
                console.log(errors);
            }
        },
        async listSpecialDiscountIds({ commit }, customerUuid){
            commit("loading", true);
            try{
                let response = await customers.listSpecialDiscountIds(customerUuid);                commit("setSdIds", response.list)
            } catch (errors) {
                console.log(errors);
            } finally {
                commit("loading", false);
            }
        },
        updateSdId: async ({ commit, state }, { param, action }) => {
            commit("loading", true);
            try {
                let response = await customers.updateSpecialDiscountId(param);
                if(action == 'approve'){
                    notification.success("Special Discount application has been approved")
                } else {
                    notification.success("Special Discount application has been rejected")
                }
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        voidSdId: async ({ commit, state }, param) => {
            commit("loading", true);
            try {
                let response = await customers.voidSpecialDiscountId(param);
                notification.success("Special Discount has been voided");
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
    }
};
